<section>

    <div class="p-5 card">

        <div class="flex justify-between items-center pb-5 border-b">
            <p class="text-lg font-semibold">Reviews & Ratings</p>
            <button class="btn btn-sm btn-primary" onclick="addReviewModel.showModal()"><i class="ri-add-line"></i> Add Review</button>
        </div>

        <ul class="grid grid-cols-1 gap-4 mt-5">

            @for (i of reviewsList; track $index) {

            <li class="p-3 bg-zinc-50 border rounded-lg ">
                <div class="flex items-end justify-between ">
                    <div>
                        <div>
                            <p class="font-semibold text-sm">{{i?.user?.name}}</p>
                            <!-- <span>{{i.is_active == true ? 'Active' : 'Unpublished'}}</span> -->
                        </div>
                        <small class="text-zinc-400"><i>{{i?.created_at | date}}</i></small>
                    </div>
                    <div class="p-1 px-3 bg-white border rounded-lg flex items-center gap-2 justify-center">
                        <p class="text-sm">Ratings {{i?.rating}} </p>

                        <div class="rating rating-sm rating-half">
                            @for (r of ratingPointers; track $index) {
                            <input type="radio" disabled readonly [name]="'rating-' + i.user_id"
                                class="mask mask-star-2 bg-amber-500"
                                [ngClass]="{'mask-half-1': r % 1 !== 0, 'mask-half-2': r % 1 === 0}"
                                [checked]="i.rating === r ? true : false" />
                            }
                        </div>


                    </div>
                </div>
                <hr class="my-3">
                <p class="text-sm">
                    {{i.review}}
                </p>
                <hr class="my-3">
                <div class="flex items-center justify-end text-sm gap-3">

                    <button class="btn btn-sm bg-white border rounded-full text-sm" (click)="togglePublish(i.id, i.is_active)">
                        <span class="w-2 h-2 rounded-full " [ngClass]="{'bg-green-600': i.is_active, 'bg-red-600': !i.is_active}"></span>
                        <span  [ngClass]="{'text-green-600': i.is_active, 'text-red-600': !i.is_active}">{{i.is_active == true ? 'Published' : 'Unpublished'}}</span>
                    </button>

                </div>

            </li>
            }

        </ul>


    </div>

</section>




<dialog #reviewModal id="addReviewModel" class="modal">
    <div class="modal-box max-w-sm p-0">

        <div class="px-5 py-3 border-b flex justify-between items-center">
            <h4 class="font-bold">Add Review</h4>
            <div class="modal-action m-0">
                <form method="dialog">
                    <button (click)="restForm()" type="submit" class="btn btn-sm btn-circle"><i
                            class="ri-close-line"></i></button>
                </form>
            </div>
        </div>
        <form [formGroup]="reviewForm" (ngSubmit)="saveReview()">
            <div class="p-5">

                <div>
                    <label class="form-control w-full ">
                        <div class="label">
                            <span class="label-text req">Select User</span>
                        </div>
                        <select [ngClass]="{'error': reviewForm.get('user_id')?.invalid && reviewForm.get('user_id')?.touched}"
                         class="select select-bordered" formControlName="user_id">
                            <option disabled selected>Pick one</option>
                            @for (i of usersList; track $index) {
                            <option value="{{i.id}}">{{i.name}}</option>
                            }
                        </select>
@if (reviewForm.get('user_id')?.invalid && (reviewForm.get('user_id')?.touched || submitted)) {
                        <span class="text-red-500 text-xs">User is required</span>
                        }
                    </label>
                </div>

                <div class="mt-3">
                    <div class="flex items-center justify-between">
                        <div class="label">
                            <span class="label-text req">Rating</span>
                        </div>
                        <div class="rating rating-md rating-half ">
                            @for (r of ratingPointers; track $index) {
                                <input type="radio" formControlName="rating" [value]="r" class="mask mask-star-2 bg-amber-500"
                                [ngClass]="{'mask-half-1': r % 1 !== 0, 'mask-half-2': r % 1 === 0}"
                                />
                            }
                        </div>
                    </div>
                    @if (reviewForm.get('rating')?.invalid && reviewForm.get('rating')?.touched) {
                        <span class="text-red-500 text-xs">Rating is required</span>
                    }
                </div>


                <div>
                    <label class="form-control w-full ">
                        <div class="label">
                            <span class="label-text req">Review</span>
                        </div>
<textarea [ngClass]="{'error': reviewForm.get('review')?.invalid && (reviewForm.get('review')?.touched || submitted)}" name="" id="" class="textarea textarea-bordered w-full"
                            formControlName="review"></textarea>
                    </label>
@if (reviewForm.get('review')?.invalid && (reviewForm.get('review')?.touched || submitted)) {
                      <span class="text-red-500 text-xs">
                        @if (reviewForm.get('review')?.errors?.['required']) {
                          Review is required / cannot be only spaces.
                        } @else if (reviewForm.get('review')?.errors?.['trim']) {
                          Please remove leading and trailing spaces.
                        } @else if (reviewForm.get('review')?.errors?.['reviewMinLength']) {
                          Review must be at least {{ reviewForm.get('review')?.errors?.['reviewMinLength']?.requiredLength }} characters.
                        } @else if (reviewForm.get('review')?.errors?.['reviewMaxLength']) {
                          Review must be at most {{ reviewForm.get('review')?.errors?.['reviewMaxLength']?.requiredLength }} characters.
                        } @else if (reviewForm.get('review')?.errors?.['reviewAllowedChars']) {
                          Invalid characters detected.
                        } @else if (reviewForm.get('review')?.errors?.['invalidHtml']) {
                          HTML/JavaScript tags are not allowed.
                        } @else {
                          Please enter a valid review.
                        }
                      </span>
                    }

                </div>

            </div>
            <div class="px-5 py-2 border-t flex justify-end">
                                <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                        @if (isreqSending) {
                            <i class="ri-loader-2-line animate-spin"></i>
                        }@else {
                            <span>Save</span>
                        }
                    </button>
            </div>
        </form>
    </div>
</dialog>
